import React from "react";

const Menu = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    >
      <path d="M1 12h22M1 5h22M1 19h22" />
    </g>
  </svg>
);

export default Menu;



// WEBPACK FOOTER //
// ./src/theme/icons/Menu.js